
import { cn } from "../lib/utils";

function Question( { className, ...props } ) {

  return (

    <div

      className={ cn( "grid grid-cols-[auto_1fr] w-full lg:gap-x-4", className ) }

      { ...props }

    />

  )

}

function QuestionHeader( { className, ...props } ) {

  return (

    <div

      className={ cn( "flex flex-col mt-1.5 mb-3", className ) }

      { ...props }

    />

  )

}

function QuestionLabel( { className, ...props } ) {
  
  return (

    <p

      className={ cn( "font-bold text-blue-primary sm:text-xl lg:text-2xl leading-[1.15]", className ) }

      { ...props }

    />

  )

}

function QuestionKicker( { className, ...props } ) {

  return (

    <p

      className={ cn( "text-blue-primary sm:text-lg lg:text-xl", className ) }

      { ...props }

    />

  )

}

function QuestionNumber( { className, ...props } ) {

  return (

    <div className="bg-blue-fresh rounded-full h-8 sm:h-10 w-8 sm:w-10 flex items-center justify-center outline-5 outline-white -translate-x-[calc(50%+0.5px)]">

      <span 

        className={ cn( "font-bold text-white sm:text-xl", className ) }
        
        { ...props } 
          
      />

    </div>

  )

}

export {

  Question,

  QuestionHeader,

  QuestionKicker,

  QuestionLabel,

  QuestionNumber,
  
}
